import { render, staticRenderFns } from "./struktur_organisasi.vue?vue&type=template&id=a1037d90&"
import script from "./struktur_organisasi.vue?vue&type=script&lang=js&"
export * from "./struktur_organisasi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports